// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b2334456","513":"fcca0ab2","633":"2326fc24"}[chunkId] + ".chunk.js";
};